var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25016 8.79166H3.25L3.25 5.60449H5.75033L5.75033 8.79166H7.75016L7.75016 3.91666L4.50016 1.45858L1.25016 3.91666L1.25016 8.79166ZM0.708496 9.33333L0.708496 3.64583L4.50016 0.781494L8.29183 3.64583L8.29183 9.33333H5.20866L5.20866 6.14616H3.79166L3.79166 9.33333H0.708496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/homeWhite.9dde8dcd101be77e2eb596c90cf10d28.svg";
export { ForwardRef as ReactComponent };